import { AssessmentQuestionShell } from '@components/pages/assessment-shell/components/assessment-question-shell.component';
import { HelmetWrapper } from '@components/shared/helmet.component';
import { PageviewTracker } from '@components/shared/pageview-tracker.component';
import { useGetCyberAssessment } from '@queries/cyber-assessment.query';
import { isCyberAssessmentQuestionnaireEmpty } from '@utils/cyber-assessment/model.util';
import React from 'react';
import { useParams } from 'react-router-dom';
import { CyberAssessmentEmptyState } from './cyber-assessment-empty-state.component';
import { CyberAssessmentLayout } from './cyber-assessment-layout.component';
import { CyberAssessmentQuestionComponent } from './cyber-assessment-question.component';
import { useCyberAssessmentQuestionPageModel } from './use-cyber-assessment-question-page-model.hook';

export const CyberAssessmentQuestionPage: React.FC = () => {
  const { cyberAssessmentId } = useParams();
  const { data: cyberAssessment } = useGetCyberAssessment(cyberAssessmentId);
  const pageModel = useCyberAssessmentQuestionPageModel();

  if (cyberAssessment && isCyberAssessmentQuestionnaireEmpty(cyberAssessment)) {
    return (
      <PageviewTracker>
        <HelmetWrapper title="Cyber Questionnaire" />
        <CyberAssessmentLayout cyberAssessment={cyberAssessment}>
          <CyberAssessmentEmptyState />
        </CyberAssessmentLayout>
      </PageviewTracker>
    );
  }

  if (!pageModel) {
    return null;
  }

  return (
    <PageviewTracker>
      <HelmetWrapper title="Cyber Questionnaire" />
      <CyberAssessmentLayout
        currentChapterId={pageModel.currentChapter.id}
        currentSectionId={pageModel.currentSection.id}
        cyberAssessment={pageModel.cyberAssessment}
      >
        <AssessmentQuestionShell
          currentQuestionIndex={pageModel.safeCurrentQuestionIndex}
          headerItems={[
            {
              href: pageModel.breadcrumbHref,
              label: 'Back to Sections',
            },
            { label: `Section ${pageModel.currentSectionIndexInChapter + 1}` },
          ]}
          onSlotClick={pageModel.setQuestionIndex}
          progress={
            pageModel.questionLabels.filter((item) => item.isComplete).length /
            Math.max(pageModel.questionLabels.length, 1)
          }
          questionLabels={pageModel.questionLabels}
          sectionIndex={pageModel.currentSectionIndexInChapter}
          sectionTitle={pageModel.currentSection.title}
        >
          <CyberAssessmentQuestionComponent
            answer={pageModel.currentAnswer}
            cyberAssessmentId={pageModel.cyberAssessment.id}
            isReadOnly={pageModel.isReadOnly}
            onNext={pageModel.goToNext}
            onPrevious={pageModel.goToPrevious}
            previousQuestion={pageModel.safeCurrentQuestionIndex > 0 || pageModel.currentSectionIndex > 0}
            question={pageModel.currentQuestion}
            questionNumber={pageModel.safeCurrentQuestionIndex + 1}
          />
        </AssessmentQuestionShell>
      </CyberAssessmentLayout>
    </PageviewTracker>
  );
};
